/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import axios from "axios";
import { pathConstants } from "@/shared/pathConstants";
import Vue from "vue";

const FICHE_API = "/fiche";

const getFichesWithMapping = function(isPersonnePhysique, isPersonneMorale) {
  return axios
    .get(
      pathConstants.API +
        FICHE_API +
        `/with-mapping?isPersonnePhysique=${isPersonnePhysique}&isPersonneMorale=${isPersonneMorale}`
    )
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("getFichesWithMapping", err);
      }
    );
};

export const ficheService = {
  getFichesWithMapping
};
